module.exports = __webpack_public_path__ + "static/media/wash.5f8394b4.png";